export default __webpack_public_path__ + "24.01.2017_Offener_Brief_an_den_Gesundheitsminister91f52c4e424cb8dc6156bb49ee321f2e.pdf";